export default "__VITE_ASSET__e2298008__"